import router from "src/routes/routes";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

export const mileageSettingsService = {
  get: () => api.getCall("/api/mileage_settings"),
  save: (settings) => api.postCall("/api/mileage_settings", settings),
};
